import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-render-schema'
import {GithubRepositoryCommit} from '@/model/resource/GithubRepositoryCommit'
import {$} from '@/facade'

export class ListGithubRepositoryCommitSchema extends DefaultSchema {
  readonly name = 'ListGithubRepositoryCommit'

  readonly fieldSet: FieldSet<GithubRepositoryCommit> = {
    githubRepository: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.githubRepository?.name,
      },
    }),
    githubUser: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.githubUser?.login,
      },
    }),
    message: (): FieldComponent => ({
      is: Component.Render,
    }),
    url: (schema): FieldComponent => ({
      is: Component.RenderAnchor,
      bind: {
        href: schema.model.url,
        label: schema.model.url,
        target: '_blank',
      },
    }),
    committedAt: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: $.filter.datetime(schema.model.committedAt),
      },
    }),
    createdAt: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: $.filter.datetime(schema.model.createdAt),
      },
    }),
  }
}
